import { createAction, props } from '@ngrx/store';
import { IAddressGroup } from '@core/models/address-group';

export const GetAddressGroups = createAction('[GetAddressGroups] Action');

export const FinishAddressGroups = createAction(
  '[FinishAddressGroups] Action',
  props<{ addressGroups: IAddressGroup[] }>()
);
